import api from '../clients/api';
import { ManageCollectionRequest, SearchRequest } from '@kimuno/api-sdk/lib/types/requests/Common';
import { ContentType } from '@kimuno/api-sdk/lib/types/responses/MindItem';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
  getDownloadInformation,
  getSearchSuggestions,
  manageCollections,
  getMindItem,
  getMindItemToken,
  createPublicMindItemLink,
  getPublicMindItem,
  getSiblings,
  getTopics,
  pinMindItem,
  unpinMindItem,
  search,
};

function getMindItem(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'getMindItem', { mindItemId });
  return handleUnauthorized(() => api.mindItem.getMindItem(mindItemId));
}

function getMindItemToken(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'getMindItemToken', { mindItemId });
  return handleUnauthorized(() => api.mindItem.getMindItemToken(mindItemId));
}

function createPublicMindItemLink(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'createPublicMindItemLink', { mindItemId });
  return handleUnauthorized(() => api.mindItem.createPublicMindItemLink(mindItemId));
}

function getPublicMindItem(accessToken: string) {
  notifyBugsnagNetwork('mindItem', 'getPublicMindItem', { accessToken });
  return api.mindItem.getPublicMindItem(accessToken);
}

function getSiblings(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'getSiblings', { mindItemId });
  return handleUnauthorized(() => api.mindItem.getMindItemSiblings(mindItemId));
}

function getDownloadInformation(
  mindItemId: string,
  trackingInfo: { sessionId?: number; deviceId?: string; searchId?: string; position?: number}
) {
  notifyBugsnagNetwork('mindItem', 'downloadInformation', { mindItemId, ...trackingInfo });
  return handleUnauthorized(() => api.mindItem.downloadInformation(mindItemId, trackingInfo));
}

function pinMindItem(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'pinMindItem', { mindItemId });
  return handleUnauthorized(() => api.mindItem.pinMindItem(mindItemId));
}

function unpinMindItem(mindItemId: string) {
  notifyBugsnagNetwork('mindItem', 'unpinMindItem', { mindItemId });
  return handleUnauthorized(() => api.mindItem.unpinMindItem(mindItemId));
}

function search(searchParams: SearchRequest, abortSignal?: AbortSignal) {
  notifyBugsnagNetwork('mindItem', 'search', { searchParams });
  return handleUnauthorized(() => api.mindItem.search(searchParams, abortSignal));
}

function getSearchSuggestions(
  searchTerm: string,
  contentType?: ContentType[],
  abortSignal?: AbortSignal,
) {
  notifyBugsnagNetwork('mindItem', 'getSearchSuggestions', { searchTerm, contentType });
  return handleUnauthorized(() => api.mindItem.searchSuggestions(searchTerm, contentType, abortSignal));
}

function getTopics(subject: string) {
  notifyBugsnagNetwork('mindItem', 'getTopics', { subject });
  return handleUnauthorized(() => api.mindItem.getTopics(subject));
}

function manageCollections(productId: string, payload: ManageCollectionRequest) {
  notifyBugsnagNetwork('mindItem', 'manageCollections', { productId, payload });
  return handleUnauthorized(() => api.mindItem.manageItemInMultipleCollections(productId, payload));
}

export default service;
